import { render, staticRenderFns } from "./stories.vue?vue&type=template&id=57c83c9a&scoped=true&lang=true&"
import script from "./stories.vue?vue&type=script&lang=js&"
export * from "./stories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c83c9a",
  null
  
)

export default component.exports